import React from 'react';
import styled from 'styled-components';
import { Text } from '@catalogo/theme-text';
import Info from '@catalogo/ui-americanas-desktop-svg/icon-alert-info.svg';

export const InformationWarning = ({ text, className }) => (
  <Container className={className}>
    <Info fill="#24cbff" height="20" width="20" />
    <TextWarning>{text}</TextWarning>
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.info.light};
  border-radius: 4px;
  padding: 15px;
  margin-top: 20px;
`;

const TextWarning = styled(Text)`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize['xs']};
  line-height: normal;
  color: ${({ theme }) => theme.grey.darker};
  margin-left: 10px;
`;
